import { createI18n } from 'vue-i18n'

import elEn from 'element-plus/es/locale/lang/en'
import elZhCn from 'element-plus/es/locale/lang/zh-cn'
import zh_cn from './lang/zh-cn.js'
import en from './lang/en.js'
import localStorageTool from '@/utils/localStorage'
import settings from '@/settings'
import ElementPlus from 'element-plus'

const currentLocale = localStorageTool.get('APP_LANG') || settings.LANG
export const messages = {
	'zh-cn': {
		...zh_cn
	},
	en: {
		...en
	}
}

export const i18n = createI18n({
	legacy: false,
	locale: currentLocale,
	fallbackLocale: settings.LANG,
	globalInjection: true,
	messages
})

const locale = {
	install(app) {
		app.use(i18n)
		let elLocale
		switch (currentLocale) {
			case 'zh-cn':
				elLocale = elZhCn
				break;
			case 'en':
				elLocale = elEn
				break;
			default:
				break;
		}
		app.use(ElementPlus, {
			locale: elLocale,
			// 支持 large、default、small
			size: localStorageTool.get('size') || 'default'
		})

	}
}

export default locale
